export const errorBoundaryActionTypes = {
	SET_ERROR: 'SET_ERROR',
} as const;
